import * as React from 'react';
import { Box, Heading, Paragraph } from '@aksara-ui/core';

interface SignupSuccessProps {
  email?: string;
}

export const SignupSuccess: React.FC<SignupSuccessProps> = ({ email }) => {
  const truncatedEmail = React.useMemo(() => {
    if (email) {
      const [address, domain] = email.split('@');
      return `${address.split('').splice(0, 3).join('')}******@${domain}`;
    }

    return undefined;
  }, [email]);

  return (
    <>
      <Box mb="xl">
        <Heading as="h3" fontFamily="brand" fontWeight={700} m={0} scale={800}>
          Check your email
        </Heading>
      </Box>
      <Paragraph scale={300}>
        We&apos;ve sent you a confirmation link to{' '}
        {truncatedEmail ? <strong>{truncatedEmail}</strong> : 'your email address'}. Please click the link to confirm
        your email address.
      </Paragraph>
    </>
  );
};
